import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useRemoveMemberShadowBanMutation = createMutationHook(
  MembershipsCreatorApiClient.removeMemberShadowBan,
  {
    mutationKey: ['removeMemberShadowBan'],
  },
)
